import React from 'react';

const CrashIcon = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 19 20" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="CrashIcon_a" d="M432.41 219.9h16.21v-1.11h-16.21z" />
      <path id="CrashIcon_b" d="M446.13 214.7l.09.43.94-.2-.72.86.73.75-1-.02-.31 1.06-.61-.71-.99.34.58-1.29-.4-.18-.99 2.21 1.66-.57.93 1.1.46-1.52 1.73.04-1.2-1.23 1.27-1.53z" />
      <path
        id="CrashIcon_c"
        d="M435.06 215.69l-3.61-3.61-1.19-1.21c-.33-.33-.36-.9-.02-1.23l.53-.53c.33-.33.93-.27 1.26.06l1.09 1.08 6.98-6.98-1.08-1.09c-.33-.33-.4-.92-.07-1.25l.54-.54c.33-.34.9-.31 1.23.02l4.82 4.8 2.34 4.84c.22.48.12 1.03-.28 1.43l-6.28 6.28c-.39.4-.95.5-1.42.27zm9.96-8.6l-8.09 8.08 3.52 1.73 6.29-6.29zm-3.17-2.08a1.23 1.23 0 1 0 1.74 0 1.23 1.23 0 0 0-1.74 0zm-6.99 6.99a1.23 1.23 0 1 0 1.75 1.73 1.23 1.23 0 1 0-1.75-1.73z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#CrashIcon_a" transform="translate(-430 -200)" />
    <use fill="currentColor" xlinkHref="#CrashIcon_b" transform="translate(-430 -200)" />
    <use fill="currentColor" xlinkHref="#CrashIcon_c" transform="translate(-430 -200)" />
  </svg>
);

export default CrashIcon;
